// extracted by mini-css-extract-plugin
export var scrollArea = "_o1-0";